export default __webpack_public_path__ + "static/media/198property-gallery2.774cf3fd.webp";